module.exports = __webpack_public_path__ + "font_hui.68ec0d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/font_hui.png
// module id = Zoog
// module chunks = 0